// extracted by mini-css-extract-plugin
export default {"round":"FounderScreen_round__TPUYV"};